export enum SchoolCandidateSort {
    FirstName = 1,
    DateOfBirth = 2,
    PermanentAddress = 3,
    PermanentAddressNote = 5,
    Status = 6
}